import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidents`,
	params: { userId, role }
});

export const GetIncidentDetailsRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidentDetails`,
	params: { userId, tableId }
});

export const GetIncidentDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetIncidentDropdowns`
});

export const EditIncidentDetailsRequest = incidentTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/EditIncidentDetails`,
	data: incidentTrackerDto
});

export const CreateIncidentRequest = incidentTrackerDto => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/CreateIncident`,
	data: incidentTrackerDto
});

export const DeleteIncidentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/DeleteIncident`,
	params: { userId, tableId }
});

export const ExportIncidentsRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/ExportIncidents`,
	params: { userId, role }
});

export const GetAutocompleteFieldsRequest = siteId => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetAutocompleteFields`,
	params: { siteId }
});

export const AddAttachmentRequest = (userId, incidentId, tempFilePath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/AddAttachment`,
	data: { userId, incidentId, tempFilePath }
});

export const DownloadAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/DownloadAttachment`,
	params: { userId, tableId }
});

export const RemoveAttachmentRequest = (userId, tableId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/RemoveAttachment`,
	params: { userId, tableId }
});

export const GetCommentsRequest = id => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IncidentTracker/GetComments`,
	params: { id }
});

export const AddCommentRequest = (id, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/AddComment`,
	data: { id, userId, comment }
});

export const AddDropdownFieldRequest = (userId, name, value, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/AddDropdownField`,
	data: { userId, name, value, relations }
});

export const RemoveDropdownFieldRequest = (userId, name, value, id, relations) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}IncidentTracker/RemoveDropdownField`,
	data: { userId, name, value, id, relations }
});
